<template>
  <div>
   <div class="searchBox">
    <div class="searchLeft">
      <el-date-picker
       size="medium"
        v-model="searchForm.startTime"
        type="date"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptionsStart"
        placeholder="请选择开始时间">
      </el-date-picker>
      <el-date-picker
        size="medium"
        v-model="searchForm.endTime"
        type="date"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptionsEnd"
        placeholder="请选择结束时间">
      </el-date-picker>
      <el-button size="medium" type="primary" icon="el-icon-search" @click="getTableList">搜索</el-button>
      <a :href="url+'/companyIncomeDaily/export?startTime='+searchForm.startTime + '&&endTime='+searchForm.endTime+'&&type='+1" style="margin-left:20px">
         <el-button size="medium" type="warning" icon="el-icon-folder-opened">导出</el-button>
      </a>
    </div>
   </div>
   <el-table
    border
    :data="tableData"
    height="73vh"
    style="width: 100%">
    <!-- <el-table-column
      width="160"
      label="充币时间">
      <template slot-scope="scope">
        <span>{{$selfFunc.dayjsFunc(scope.row.doneTime)}}</span>
      </template>
    </el-table-column> -->
    <el-table-column
      prop="date"
      width="110"
      label="日期">
    </el-table-column>
    <el-table-column
      prop="balance"
      label="当日产出(FIL)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.income,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="pledge"
      width="180"
      label="当日产出立即释放(25%)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.immediateRelease,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="frozenGrowth"
      width="170"
      label="当日新增待释放(75%)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.frozenGrowth,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="lineRelease"
      width="120"
      label="线性已释放">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.lineRelease,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="frozenGrowth"
      label="当日总释放">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.todayTotalRelease,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="frozen"
      width="120"
      label="总释放(FIL)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.totalRelease,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="frozen"
      width="120"
      label="总待释放(FIL)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.totalFrozen,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="frozen"
      width="170"
      label="新增变化量(总待释放)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.totalFrozenGrowth,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="frozen"
      width="240"
      label="当日总释放+新增变化量(总待释放)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.totalReleaseTotalFrozenGrowth,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      width="160"
      prop="createTime"
      label="统计时间">
    </el-table-column>
  </el-table>
  <div class="pageBox" v-if="totalNum > 0">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[16, 32, 50, 60]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pickerOptionsStart: {
        disabledDate: time => {
          let endDateVal = this.searchForm.endTime;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.searchForm.startTime;
          if (beginDateVal) {
            return (time.getTime()<new Date(beginDateVal).getTime()-1*24*60*60*1000);
          }
        }
      },
      totalNum:0,
      searchForm:{
        page:1,
        pageSize:16,
        startTime: '',
        endTime: '',
        type: 1
      },
      tableData: [],
      url: window.g.host
    };
  },
  created() {
    this.getTableList()
  },
  methods: {
    async getTableList(val){
      if(val){
        this.searchForm.page=1;
      }
       let res = await this.$http.companyIncomeDailyExport({...this.searchForm});
        if (res) {
          this.tableData=res.data.list
          console.log(res.data)
          this.totalNum=Number(res.data.totalSize)
        }
    },
    handleSizeChange(val) {
      this.searchForm.page = 1;
      this.searchForm.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getTableList();
    }
  }
};
</script>
<style scoped>
.unit{
  position: absolute;
  right: 10px;
  color:#999;
}
</style>
